import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BugReportIcon from '@material-ui/icons/BugReport';
import StatsCard from '../shared/StatsCard';
import DescriptionIcon from '@material-ui/icons/Description';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import TimelineIcon from '@material-ui/icons/Timeline';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

const SystemHealth = ({ system }) => {
  const classes = useStyles();
  
  const { logging, eventDeduplication, lifecycle } = system;
  
  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" className={classes.title}>
        <BugReportIcon />
        System Health
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Total Logs"
            value={logging.totalLogs.toLocaleString()}
            subtitle={`${logging.errorLogs} errors`}
            icon={<DescriptionIcon />}
            color={logging.errorLogs > 100 ? 'warning' : 'primary'}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Correlations"
            value={logging.correlations}
            subtitle="Active traces"
            icon={<TimelineIcon />}
            color="primary"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Events Processed"
            value={eventDeduplication.totalEvents.toLocaleString()}
            subtitle={`${eventDeduplication.duplicatesBlocked} duplicates blocked`}
            icon={<FilterNoneIcon />}
            color="primary"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatsCard
            title="Lifecycle Events"
            value={lifecycle.totalEvents.toLocaleString()}
            subtitle="All match events"
            icon={<TimelineIcon />}
            color="primary"
          />
        </Grid>
      </Grid>
      
      {Object.keys(lifecycle.eventTypes || {}).length > 0 && (
        <Box mt={2}>
          <Typography variant="caption" color="textSecondary">
            Event Types: {Object.keys(lifecycle.eventTypes).join(', ')}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default SystemHealth;

